import type { RibbonGroupId } from 'owa-ribbon-ids';
import { type MailRibbonControlId, type MailRibbonGroupId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { type Layout, sections, singleRow } from 'owa-acui';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { owaComputedFn } from 'owa-computed-fn';
import { getStringRibbonId } from 'owa-ribbon-ids';

/**
 * Gets the control layout for search tools groups
 */
export const getMLRSearchToolsTabGroupLayouts: (
    group: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
) => Layout[] | undefined = owaComputedFn(function getMLRSearchToolsTabGroupLayouts(
    group: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
): Layout[] | undefined {
    switch (group) {
        case 204:
            return [
                sections(
                    singleRow(
                        getStringRibbonId(741),
                        getStringRibbonId(742),
                        getStringRibbonId(743)
                    ),
                    singleRow(
                        getStringRibbonId(745),
                        getStringRibbonId(746),
                        getStringRibbonId(747)
                    ),
                    singleRow(getStringRibbonId(749), getStringRibbonId(744))
                ),
            ];
        case 203:
            return [
                sections(
                    singleRow(
                        getStringRibbonId(739),
                        getStringRibbonId(766),
                        getStringRibbonId(740)
                    )
                ),
            ];
        default:
            return undefined;
    }
});
